
import { date }         from './validationRules/date';
import { email }        from './validationRules/email';
import { number }       from './validationRules/number';

import { checkbox }     from './validationRules/checkbox';
import { equalTo }      from './validationRules/equalTo';
import { exactLength }  from './validationRules/exactLength';
import { file }         from './validationRules/file';
import { length }       from './validationRules/length';
import { max }          from './validationRules/max';
import { maxlength }    from './validationRules/maxlength';
import { min }          from './validationRules/min';
import { minlength }    from './validationRules/minlength';
import { pattern }      from './validationRules/pattern';
import { radio }        from './validationRules/radio';

export const validationRules = {
    date,
    email,
    number,

    checkbox,
    equalTo,
    exactLength,
    file,
    length,
    max,
    maxlength,
    min,
    minlength,
    pattern,
    radio
}
